import React from 'react';
import BallPrimary from './BallPrimary';
import BallSecondary from './BallSecondary';

function Balls({ numbers, lotteryType }) {
    if (!Array.isArray(numbers[0])) {
        numbers[0] = [];
    }

    function getBalls() {
        const balls = [];
        switch (lotteryType) {
            case 'lottery':
            default:
                numbers[0].forEach(function(number) {
                    balls.push(<BallPrimary number={number} key={`primary-${number}`} />);
                });
                if (Array.isArray(numbers[1])) {
                    numbers[1].forEach(function(number) {
                        balls.push(<BallSecondary number={number} key={`secondary-${number}`} />);
                    });
                }
                break;

            case 'pick':
                numbers.forEach(function(items, index) {
                    items.forEach(function(number) {
                        balls.push(<BallPrimary number={number} key={`${number}${index}`} />);
                    });
                })
                break;

            case 'keno':
                numbers[0].forEach(function(number) {
                    balls.push(<BallPrimary number={number} key={number} />);
                });
                break;
        }

        return (
            <div className="row justify-content-md-center">
                {balls}
            </div>
        );
    }

    return getBalls();
}

export default Balls;
